export default {
    code: 'en',
    htmlLang: 'en',
    ogLocale: 'en_US',
    selectLabel: 'EN',
    meta: {
        home: {
            title: 'Klinik Pergigian Irma Ariandi — Wear Your Smile | Dental Clinic Johor Bahru',
            description: 'Dental clinic in Johor Bahru for conventional braces, clear aligners, FRC and zirconia crowns & bridges. Good dentistry. Honest advice. Transparent fees. Human care.',
        },
    },
    nav: {
        home: 'Home',
        treatments: 'Treatments',
        teen: 'Teen Smile',
        teenBadge: "Parents' guide",
        international: 'International Patients',
        kolum: 'Coffee With Dr. Irma',
        doctors: 'Our Doctors',
        stories: 'Patient Stories',
        contact: 'Contact',
        book: 'Book an appointment',
        menu: 'Menu',
        close: 'Close',
        language: 'Language',
        treatmentsMenu: [
            { slug: 'conventional-braces', title: 'Conventional Braces', desc: 'Proven orthodontic alignment' },
            { slug: 'clear-aligners', title: 'Clear Aligners', desc: 'A more discreet orthodontic option' },
            { slug: 'frc', title: 'FRC', desc: 'Front-tooth replacement without major surgery' },
            { slug: 'zirconia-crowns-bridges', title: 'Zirconia Crown & Bridge', desc: 'Strong, aesthetic ceramic restorations' },
            { slug: 'aesthetic-veneers', title: 'Aesthetic Veneers & Smile Makeover', desc: 'A smile designed around you' },
        ],
        digitalLink: { path: '/digital-dentistry', title: 'Digital Dentistry', desc: 'The technology behind modern treatment planning' },
        internationalMenu: [
            { path: '/international/singapore', title: 'Singapore', desc: 'For patients travelling from Singapore' },
            { path: '/international/indonesia-batam', title: 'Indonesia / Batam', desc: 'For patients from Batam and Indonesia' },
            { path: '/international', title: 'Overview', desc: 'How cross-border care works' },
        ],
        doctorsMenu: [
            { path: '/doctors/dr-irma-ariandi', title: 'Dr. Irma (DDS, UKM)', desc: 'Dentist · Educator · Writer' },
            { path: '/doctors/dr-ariandi', title: 'Dr. Ariandi (DDS, UKM)', desc: 'Dentist' },
        ],
    },
    cta: {
        whatsapp: 'WhatsApp us',
        whatsappLong: 'WhatsApp the clinic',
        book: 'Book an appointment',
        askIrma: 'Ask Dr. Irma',
        explore: 'Explore treatments',
        email: 'Email us',
    },
    journeySteps: [
        { k: '01', t: 'ASSESS', d: 'A proper look, a proper diagnosis.' },
        { k: '02', t: 'EXPLAIN', d: 'We explain what we see, in plain language.' },
        { k: '03', t: 'OPTIONS', d: 'Every reasonable option, on the table.' },
        { k: '04', t: 'FEES', d: 'Fees before treatment, not after.' },
        { k: '05', t: 'DECIDE', d: 'You decide. We advise.' },
        { k: '06', t: 'TREAT', d: 'Treatment, at your pace.' },
        { k: '07', t: 'REVIEW', d: 'We review, adjust and maintain.' },
    ],
    journeyNote: 'Every patient is different. Your actual pathway is always explained by the doctor after examination.',
    home: {
        hero: {
            badge: 'Klinik Pergigian Irma Ariandi · Johor Bahru',
            titleA: 'WEAR YOUR',
            titleB: 'SMILE.',
            sub: 'Good dentistry. Honest advice. Transparent fees. Human care.',
            sub2: 'Orthodontic, restorative and aesthetic dental care in Johor Bahru — planned carefully, explained honestly.',
            chips: ['BRACES', 'CLEAR ALIGNERS', 'FRC', 'ZIRCONIA', 'VENEERS'],
            welcome: 'Welcoming patients from Johor, Singapore and Indonesia.',
            imgCaption: 'Johor Bahru, Malaysia',
            imgAlt: 'Illustrative: a healthy smile',
        },
        marquee: ['Good dentistry', 'Pergigian yang baik', '用心的牙科', 'நல்ல பல் சிகிச்சை', 'Honest advice', 'Nasihat yang jujur', '诚实的建议', 'நேர்மையான ஆலோசனை', 'Transparent fees', 'Yuran yang telus', '透明的收费', 'வெளிப்படையான கட்டணம்', 'Human care', 'Penjagaan yang manusiawi', '人性化的关怀', 'மனிதநேயமான கவனிப்பு'],
        pathways: {
            eyebrow: 'Where would you like to begin?',
            title: 'What would you like to change about your smile?',
            sub: 'Tell us where you are, and we will take you to the right information — and the right conversation.',
            items: [
                { id: 'straighter', label: 'I want straighter teeth.', to: '/treatments/conventional-braces' },
                { id: 'discreet', label: 'I want a discreet way to straighten my teeth.', to: '/treatments/clear-aligners' },
                { id: 'brighter', label: 'I want a brighter, more aesthetic smile.', to: '/treatments/aesthetic-veneers' },
                { id: 'shape', label: 'I want to change the shape or proportion of my teeth.', to: '/treatments/aesthetic-veneers' },
                { id: 'broken', label: 'I have a broken or damaged front tooth.', to: '/treatments/frc' },
                { id: 'restore', label: 'I need to restore damaged teeth.', to: '/treatments/zirconia-crowns-bridges' },
                { id: 'teen', label: 'I am looking for braces for my teenager.', to: '/teen-smile' },
                { id: 'sg', label: 'I am travelling from Singapore.', to: '/international/singapore' },
                { id: 'id', label: 'I am travelling from Indonesia.', to: '/international/indonesia-batam' },
                { id: 'unsure', label: 'I am not sure what I need.', to: '/contact' },
            ],
        },
        pillars: {
            eyebrow: 'Our five pillars',
            title: 'Focused dentistry, done properly',
            sub: 'We concentrate our practice on five treatment areas — so we can do them well, and explain them honestly.',
            ctaCard: { title: 'Not sure which treatment fits?', text: 'Start with a conversation — we will help you understand your options.', cta: 'Plan a consultation' },
        },
        why: {
            eyebrow: 'Why patients choose us',
            title: 'Why patients choose — and remember — this clinic',
            items: [
                { title: 'Honest advice', text: 'If a treatment is not needed, we say so. If a more reasonable option exists, we mention it.' },
                { title: 'Transparent treatment discussions', text: 'Options and fees are explained clearly before treatment begins. No surprises.' },
                { title: 'Human care', text: 'Patients remember the doctor who listened, and the one they could trust.' },
                { title: 'Clinical experience', text: 'Careful assessment and treatment carried out with care.' },
                { title: 'Modern dentistry', text: 'Digital technology supports diagnosis and planning, where clinically appropriate.' },
            ],
        },
        doctors: {
            eyebrow: 'Meet your dentists',
            title: 'Dr. Irma Ariandi & Dr. Ariandi',
            sub: 'Two dentists, one approach: examine carefully, explain clearly, treat gently.',
            irmaLine: 'Dentist · Dental educator · Writer — has written the health segment for Utusan Malaysia.',
            ariandiLine: 'Dentist',
            cta: 'Meet the doctors',
        },
        teen: {
            eyebrow: 'Teen Smile',
            title: "A parents' guide to teen braces",
            text: 'For parents in Johor Bahru who want honest answers — when the right time is, what happens at a first assessment, and how to decide calmly.',
            points: [
                'A first assessment without pressure',
                'Conventional braces vs clear aligners for teens',
                'School, sports and hygiene during treatment',
            ],
            cta: 'Read the parents\u2019 guide',
        },
        intl: {
            eyebrow: 'International patients',
            title: 'Cross-border care, planned properly',
            sg: { title: 'From Singapore', text: 'Clear aligner care in Johor Bahru, with a review structure planned so visits can be combined with a trip to JB.' },
            id: { title: 'From Indonesia / Batam', text: 'Clear aligner and selected restorative care in Johor Bahru, with simple travel guidance and easy communication.' },
            aligner: 'Clear aligners are the hero treatment for our international patients — clinical reviews are planned approximately every 3 months where clinically appropriate, so visits can be combined with a trip to Johor Bahru.',
            note: 'Subject to individual clinical needs, treatment plan, clinic/provider terms and applicable delivery requirements.',
            cta: 'International patients',
        },
        digital: {
            eyebrow: 'Our technology',
            title: 'WE EMBRACE DIGITAL DENTISTRY',
            p1: 'Modern dentistry is not only about what we do. It is also about how we plan.',
            p2: 'At Klinik Pergigian Irma Ariandi, digital technology supports selected areas of diagnosis, treatment planning and restorative or aesthetic workflows. Our intraoral scanning technology allows us to capture a digital representation of the teeth without relying solely on conventional impressions, where clinically appropriate.',
            note: 'Technology supports clinical judgement — it does not replace it.',
            cta: 'DISCOVER DIGITAL DENTISTRY',
        },
        veneers: {
            eyebrow: 'Aesthetic Veneers & Smile Makeover',
            title: 'A smile designed around you',
            text: 'For patients who would like to improve the colour, shape, proportion, symmetry or overall appearance of their smile, aesthetic veneers may be one treatment option following a proper dental assessment. Every smile is different.',
            artist: { title: 'THE ARTIST SMILE', text: 'For patients who prefer a brighter, polished, camera-ready aesthetic. Some patients prefer a very natural shade while others prefer a brighter, more glamorous aesthetic — the goal is discussed during smile planning.' },
            cta: 'PLAN MY SMILE CONSULTATION',
            ctaWa: 'ASK ABOUT VENEER TREATMENT',
        },
        kolum: {
            eyebrow: 'Coffee With Dr. Irma',
            title: 'Columns from the dental chair',
            sub: 'Dr. Irma Ariandi writes about teeth, honesty and life — continuing her health-column legacy, now digital.',
            empty: 'The first columns in this language are being prepared. Meanwhile, here are articles from the clinic in other languages.',
            cta: 'Read Coffee With Dr. Irma',
        },
        remember: {
            eyebrow: 'What patients remember',
            title: 'What patients remember',
            sub: 'Real words from verified patients — shared with permission, names withheld. Published as they were written, in the language they were shared in.',
            themes: ['Transparent fees', 'Honest advice', 'A friendly, funny doctor', 'Clinical confidence', 'Human, empathic care'],
            verifiedLabel: 'Verified patient',
        },
        journey: {
            eyebrow: 'Our philosophy',
            title: 'Understand first. Decide later.',
        },
        nervous: {
            title: 'Nervous about seeing a dentist?',
            text: 'Tell us. We understand. Many of our patients tell us they were afraid — we take the time to explain, and you set the pace. No lectures, no pressure.',
            cta: 'Tell us on WhatsApp',
        },
        location: {
            eyebrow: 'Visit us',
            title: 'Find us in Johor Bahru',
            addressLabel: 'Address',
            addressValue: '1-24 & 1-25, Aras 1, Plaza Larkin, Jalan Garuda, 80350 Johor Bahru, Johor, Malaysia',
            hoursLabel: 'Opening hours',
            hoursValue: 'Sun–Thu: 10:00am – 6:00pm (lunch break 1:00 – 2:00pm) · Sat: 9:00am – 12:30pm · Fri & public holidays: closed · By appointment only',
            mapNote: 'Our clinic is located on Level 1 of Plaza Larkin (building above).',
            whatsappLabel: 'WhatsApp',
            emailLabel: 'Email',
        },
        finalCta: {
            title: 'WEAR YOUR SMILE.',
            sub: 'Start with a conversation. Tell us briefly what is on your mind — we will guide you on the next appropriate step.',
            primary: 'WhatsApp the clinic',
            secondary: 'Book an appointment',
        },
    },
    treatLabels: {
        who: 'Who may consider this treatment',
        problem: 'What problem it addresses',
        assessment: 'How assessment works',
        options: 'Treatment options',
        journey: 'Treatment journey',
        know: 'What patients should know',
        followup: 'Typical follow-up considerations',
        faq: 'Common questions',
        doctors: 'Your doctors',
        articles: 'Related reading',
        teenNoteLabel: 'For teenagers — what parents should know',
        intlNoteLabel: 'International patients',
        ctaTitle: 'Still exploring?',
        ctaText: 'Message the clinic. We will help you understand whether this treatment suits you — honestly.',
        digital: 'Digital dentistry support',
    },
    teen: {
        metaTitle: 'Teen Smile: A Parents\u2019 Guide to Teen Braces | Klinik Pergigian Irma Ariandi',
        metaDesc: 'An honest guide for parents in Johor Bahru: the right age for braces, the first orthodontic assessment, braces vs clear aligners, and school life during treatment.',
        title: 'Teen Smile',
        subtitle: "Parents' guide",
        heroText: 'Your teenager did not ask for braces — you are the one doing the research, and that is exactly the right step. This page is for parents in Johor Bahru who want to understand their teenager\u2019s options calmly and honestly.',
        ctaTitle: 'Questions about your child\u2019s teeth?',
        ctaText: 'WhatsApp our clinic. Tell us your child\u2019s age and your main concern — we will suggest the appropriate next step.',
    },
    international: {
        metaTitle: 'International Patients — Singapore & Indonesia | Klinik Pergigian Irma Ariandi',
        metaDesc: 'Dental care in Johor Bahru for patients from Singapore, Batam and Indonesia. How treatment works, review structure and appointment planning.',
        title: 'International Patients',
        subtitle: 'Singapore · Indonesia / Batam',
        heroText: 'We receive patients travelling from Singapore and Indonesia — especially for clear aligner treatment and selected restorative care. This page explains how it works, before you even contact us.',
    },
    kolum: {
        tagline: 'Dental Health · Smiles · Modern Dentistry',
        metaTitle: 'Coffee With Dr. Irma | Klinik Pergigian Irma Ariandi',
        metaDesc: 'Dental health columns by Dr. Irma Ariandi, dentist in Johor Bahru and previously a regular health columnist for Utusan Malaysia.',
        title: 'Coffee With Dr. Irma',
        sub: 'Columns by Dr. Irma Ariandi, DDS (UKM) — dentist, dental educator and writer. Previously a regular health columnist for Utusan Malaysia.',
        all: 'All',
        by: 'by',
        minRead: 'min read',
        published: 'Published',
        updated: 'Updated',
        empty: 'Columns in this language are being prepared. Meanwhile, read columns in other languages below.',
        langOf: 'Language',
        back: 'All columns',
        stillUnsure: {
            title: 'STILL UNSURE?',
            text: 'Ask Dr. Irma. Tell us briefly what concerns you and our clinic team will guide you on the next appropriate step.',
            cta: 'WhatsApp the clinic',
            note: 'WhatsApp communication helps the clinic guide you — it is not a diagnosis.',
        },
        relatedTreatment: 'Related treatment',
        authorLine: 'Written by Dr. Irma (DDS, UKM), Klinik Pergigian Irma Ariandi.',
        sampleNote: 'Sample column — content will be reviewed and verified by the clinic before official launch.',
    },
    doctors: {
        metaTitleIrma: 'Dr. Irma (DDS, UKM) — Dentist, Educator & Writer | Johor Bahru',
        metaDescIrma: 'Profile of Dr. Irma Ariandi, DDS (UKM), dentist in Johor Bahru, dental educator and previously a regular health columnist for Utusan Malaysia.',
        metaTitleAriandi: 'Dr. Ariandi (DDS, UKM) — Dentist | Klinik Pergigian Irma Ariandi, Johor Bahru',
        metaDescAriandi: 'Profile of Dr. Ariandi, DDS (UKM), dentist at Klinik Pergigian Irma Ariandi in Johor Bahru.',
        profile: 'Doctor profile',
        quals: 'Qualifications',
        interests: 'Treatment interests',
        philosophy: 'Treatment philosophy',
        articlesBy: 'Columns by',
        pendingBio: '[DOCTOR BIO TO CONFIRM]',
        pendingInterests: '[TREATMENT INTERESTS TO CONFIRM]',
        pendingPhilosophy: '[TREATMENT PHILOSOPHY TO CONFIRM]',
        cta: 'Book with',
        irmaRoles: 'Dentist · Dental educator · Writer',
        irmaColumnist: 'Dr. Irma was previously a regular health columnist for Utusan Malaysia. This digital column continues her health-writing legacy — now here, for patients in Johor Bahru, Singapore and Indonesia.',
        ariandiRoles: 'Dentist',
    },
    stories: {
        metaTitle: 'What Patients Remember | Klinik Pergigian Irma Ariandi',
        metaDesc: 'Reviews and stories from patients of Klinik Pergigian Irma Ariandi in Johor Bahru — published only after verification and with permission.',
        title: 'What patients remember',
        sub: 'Real words from verified patients — shared with permission, names withheld. Published as they were written, in the language they were shared in. We do not edit or embellish them.',
        themesTitle: 'Themes patients mention to us',
        verifiedLabel: 'Verified patient',
        caseTitle: 'Case stories',
        caseNote: 'Real case stories — the patient concern, options discussed and treatment journey — will be published only with written patient consent and professional compliance. The structure is being prepared now.',
        caseSlot: '[REAL CASE STORY TO INSERT]',
    },
    about: {
        metaTitle: 'About the Clinic | Klinik Pergigian Irma Ariandi, Johor Bahru',
        metaDesc: 'Klinik Pergigian Irma Ariandi in Johor Bahru — good dentistry, honest advice, transparent fees, human care.',
        title: 'About the clinic',
        intro: 'Klinik Pergigian Irma Ariandi is a dental clinic in Johor Bahru, Johor, Malaysia. We focus on five treatment areas — conventional braces, clear aligners, FRC, zirconia crowns & bridges and aesthetic veneers & smile makeover — with a single promise behind all of them.',
        promisesTitle: 'Our promise',
        promises: [
            { t: 'Good dentistry', d: 'Careful work, done for clear reasons.' },
            { t: 'Honest advice', d: 'What we say is what we will do — or not do.' },
            { t: 'Transparent fees', d: 'Explained before treatment, with a clear breakdown.' },
            { t: 'Human care', d: 'You are not a queue number. You are a patient we know.' },
        ],
        philosophyTitle: 'Our treatment philosophy',
        photoSlot: '[CLINIC PHOTOGRAPH TO INSERT]',
    },
    contact: {
        metaTitle: 'Contact / Appointment | Klinik Pergigian Irma Ariandi, Johor Bahru',
        metaDesc: 'Contact Klinik Pergigian Irma Ariandi in Johor Bahru via WhatsApp 011-3306 5735 or email. A simple appointment enquiry form — no account needed.',
        title: 'Contact us',
        sub: 'The fastest route is WhatsApp. If you prefer a form, we are happy to help through that too.',
        whatsappTitle: 'WhatsApp (fastest)',
        emailTitle: 'Email / appointment',
        addressTitle: 'Address',
        addressValue: '1-24 & 1-25, Aras 1, Plaza Larkin, Jalan Garuda, 80350 Johor Bahru, Johor, Malaysia',
        hoursTitle: 'Opening hours',
        hoursValue: 'Sun–Thu: 10:00am – 6:00pm (lunch break 1:00 – 2:00pm) · Sat: 9:00am – 12:30pm · Fri & public holidays: closed · By appointment only',
        formTitle: 'A short enquiry form',
        form: {
            name: 'Name',
            namePh: 'Your name',
            method: 'How should we reach you?',
            methodOptions: ['WhatsApp', 'Phone call', 'Email'],
            treatment: 'Treatment of interest',
            treatmentOptions: ['Conventional braces', 'Clear aligners', 'FRC', 'Zirconia crown & bridge', 'Aesthetic veneers', 'Not sure yet', 'Other'],
            phoneLabel: 'WhatsApp / Mobile number',
            phonePh: '12-345 6789',
            dateLabel: 'Preferred appointment date',
            timeLabel: 'Preferred time',
            timeOptions: ['Morning (10:00 AM – 1:00 PM)', 'Midday (1:00 – 3:00 PM)', 'Afternoon (3:00 – 6:00 PM)'],
            successTitle: 'Appointment request received',
            successBody: 'The clinic team will check availability and contact you to confirm. Your details are already shared with Aira — you can chat with her without repeating yourself.',
            successAira: 'Continue with Aira',
            successWa: 'Continue to WhatsApp',
            time: 'Preferred appointment date/time',
            timePh: 'e.g. This weekend, afternoon',
            country: 'You are in',
            countryOptions: ['Malaysia', 'Singapore', 'Indonesia', 'Other'],
            message: 'Short message',
            messagePh: 'Briefly tell us what is on your mind',
            submit: 'Send enquiry',
            success: 'Thank you. The clinic will get back to you shortly.',
            error: 'Sorry, sending failed. Please WhatsApp us directly.',
            consent: 'By submitting this form, you agree that we may contact you about your enquiry. Your details are used only for this purpose.',
        },
    },
    privacy: {
        metaTitle: 'Privacy Policy | Klinik Pergigian Irma Ariandi',
        metaDesc: 'Privacy policy of Klinik Pergigian Irma Ariandi — how your enquiry information is collected, used and protected.',
        title: 'Privacy Policy',
        updated: 'Version 1.0 — [DATE TO CONFIRM]',
        sections: [
            { h: 'What we collect', p: 'We collect only the information you give us through the enquiry form or WhatsApp messages — your name, preferred contact method and a summary of your enquiry. We do not request detailed medical histories through a marketing form.' },
            { h: 'How we use it', p: 'Your information is used solely to answer your enquiry and manage appointments. It is not sold or shared for third-party marketing.' },
            { h: 'Cookies and analytics', p: 'This website may use analytics tools to understand site usage in aggregate. Analytics are not used to identify you personally.' },
            { h: 'Storage and security', p: 'Enquiries are stored securely and accessed only by the clinic team for the purpose of answering you.' },
            { h: 'Your rights', p: 'For questions about your data, contact us at klinikpergigianirmaariandi@gmail.com.' },
        ],
    },
    disclaimer: {
        metaTitle: 'Website & Medical Disclaimer | Klinik Pergigian Irma Ariandi',
        metaDesc: 'Medical disclaimer of the Klinik Pergigian Irma Ariandi website — educational information, not a substitute for clinical examination.',
        title: 'Website & Medical Disclaimer',
        updated: 'Version 1.0 — [DATE TO CONFIRM]',
        sections: [
            { h: 'Educational information', p: 'Content on this website is for educational and general information purposes. It is not a substitute for clinical examination, diagnosis or an individual treatment plan.' },
            { h: 'Individual assessment is required', p: 'Treatment suitability, duration, number of visits and outcomes vary by patient. Any treatment decision requires clinical assessment by a dentist.' },
            { h: 'WhatsApp is not a diagnosis', p: 'Communication via WhatsApp helps the clinic direct you to the appropriate next step. It is not a diagnosis and does not replace examination.' },
            { h: 'No guarantees', p: 'We do not make guaranteed-outcome claims. What we promise is honest explanation, transparent fees and human care.' },
        ],
    },
    notFound: {
        title: 'This page seems to be missing',
        text: 'The link may be wrong, or the page is still being built. Let us take you back.',
        cta: 'Back to home',
    },
    footer: {
        about: 'A dental clinic in Johor Bahru. Conventional braces, clear aligners, FRC, zirconia crowns & bridges, aesthetic veneers & smile makeover.',
        quickLinks: 'Quick links',
        treatments: 'Treatments',
        international: 'International patients',
        kolum: 'Coffee With Dr. Irma',
        doctors: 'Doctors',
        contact: 'Contact',
        privacy: 'Privacy Policy',
        disclaimer: 'Website & Medical Disclaimer',
        whatsapp: 'WhatsApp',
        email: 'Email',
        address: '1-24 & 1-25, Aras 1, Plaza Larkin, Jalan Garuda, 80350 Johor Bahru, Johor, Malaysia',
        addressSlot: '',
        rights: 'Klinik Pergigian Irma Ariandi. All rights reserved.',
        disclaimerLine: 'Information on this website is educational and not a substitute for clinical examination.',
    },
};
